import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { map, Observable } from 'rxjs';

import * as fromMapSelectors from '../../../store/selectors/map.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-user-position',
  standalone: false,
  templateUrl: './user-position.component.html'
})
export class UserPositionComponent {
  private store = inject(Store);

  userPosition$: Observable<google.maps.LatLngLiteral | null>;
  userPositionMarkerOptions$: Observable<google.maps.MarkerOptions>;

  constructor() {
    this.userPosition$ = this.store.pipe(select(fromMapSelectors.selectUserPosition));
    this.userPositionMarkerOptions$ = this.store.pipe(
      select(fromMapSelectors.selectMarkerOptions),
      map((markerOptions) => ({
        ...markerOptions,
        icon: {
          scaledSize: new google.maps.Size(32, 32),
          url: '/assets/img/pin-user-position.png'
        }
      }))
    );
  }
}
